module.exports = __webpack_public_path__ + "static/media/logo.35a80ea7.svg";